module.exports = __webpack_public_path__ + "static/media/calculator-body.537fe3ad.png";